// SkeletonCardComponent.js
import styles from "@/components/ui/skeletons/CarCardSkeletonComponent.module.css";

const CarCardSkeletonComponent = () => {
  return (
    <div className={styles.skeletonCard}>
      <div className={styles.skeletonImage} />
      <div className={styles.skeletonTitle} />
      <div className={styles.skeletonAttributes}>
        <div className={styles.skeletonAttribute} />
      </div>
    </div>
  );
};

export default CarCardSkeletonComponent;
